// source: customer/customer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var common_common_pb = require('../common/common_pb.js');
goog.object.extend(proto, common_common_pb);
goog.exportSymbol('proto.mw.customer.AnalyzeSkinImagesRequest', null, global);
goog.exportSymbol('proto.mw.customer.AnalyzeSkinImagesResponse', null, global);
goog.exportSymbol('proto.mw.customer.AnalyzeSkinProblemsRequest', null, global);
goog.exportSymbol('proto.mw.customer.AnalyzeSkinProblemsResponse', null, global);
goog.exportSymbol('proto.mw.customer.AuthenticateRequest', null, global);
goog.exportSymbol('proto.mw.customer.AuthenticateResponse', null, global);
goog.exportSymbol('proto.mw.customer.CaptureMiniShopOrderRequest', null, global);
goog.exportSymbol('proto.mw.customer.CaptureMiniShopOrderResponse', null, global);
goog.exportSymbol('proto.mw.customer.ClearProductQuantitiesRequest', null, global);
goog.exportSymbol('proto.mw.customer.ClearProductQuantitiesResponse', null, global);
goog.exportSymbol('proto.mw.customer.ContactFormValue', null, global);
goog.exportSymbol('proto.mw.customer.CreateMiniShopOrderRequest', null, global);
goog.exportSymbol('proto.mw.customer.CreateMiniShopOrderResponse', null, global);
goog.exportSymbol('proto.mw.customer.CreateOrderRequest', null, global);
goog.exportSymbol('proto.mw.customer.CreateOrderResponse', null, global);
goog.exportSymbol('proto.mw.customer.DownloadInvoicePDFRequest', null, global);
goog.exportSymbol('proto.mw.customer.DownloadInvoicePDFResponse', null, global);
goog.exportSymbol('proto.mw.customer.ErrorRequest', null, global);
goog.exportSymbol('proto.mw.customer.ErrorResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetMiniShopRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetMiniShopResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetOrderFormV2GroupedRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetOrderFormV2GroupedResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetOrderFormV2Request', null, global);
goog.exportSymbol('proto.mw.customer.GetOrderFormV2Response', null, global);
goog.exportSymbol('proto.mw.customer.GetOrderSummaryRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetOrderSummaryResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetOrdersRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetOrdersResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetProductRecommendationsRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetProductRecommendationsResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetSkinAnalysisFormRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetSkinAnalysisFormResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetSkinProblemsForAnalysisRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetSkinProblemsForAnalysisResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetStudentStatusRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetStudentStatusResponse', null, global);
goog.exportSymbol('proto.mw.customer.GetSuggestedProductsRequest', null, global);
goog.exportSymbol('proto.mw.customer.GetSuggestedProductsResponse', null, global);
goog.exportSymbol('proto.mw.customer.ProductRecommendation', null, global);
goog.exportSymbol('proto.mw.customer.ProductSkinProblems', null, global);
goog.exportSymbol('proto.mw.customer.RegisterStudentRequest', null, global);
goog.exportSymbol('proto.mw.customer.RegisterStudentResponse', null, global);
goog.exportSymbol('proto.mw.customer.RequestNewPasswordTokenRequest', null, global);
goog.exportSymbol('proto.mw.customer.RequestNewPasswordTokenResponse', null, global);
goog.exportSymbol('proto.mw.customer.SaveNewPasswordRequest', null, global);
goog.exportSymbol('proto.mw.customer.SaveNewPasswordResponse', null, global);
goog.exportSymbol('proto.mw.customer.SkinAnalysisImageRequirement', null, global);
goog.exportSymbol('proto.mw.customer.SkinAnalysisSlider', null, global);
goog.exportSymbol('proto.mw.customer.SkinImage', null, global);
goog.exportSymbol('proto.mw.customer.SkinProblemScore', null, global);
goog.exportSymbol('proto.mw.customer.SkippedOrderItem', null, global);
goog.exportSymbol('proto.mw.customer.StudentDocument', null, global);
goog.exportSymbol('proto.mw.customer.SubmitContactFormRequest', null, global);
goog.exportSymbol('proto.mw.customer.SubmitContactFormResponse', null, global);
goog.exportSymbol('proto.mw.customer.TrackUsageRequest', null, global);
goog.exportSymbol('proto.mw.customer.TrackUsageResponse', null, global);
goog.exportSymbol('proto.mw.customer.UploadStudentDocumentsRequest', null, global);
goog.exportSymbol('proto.mw.customer.UploadStudentDocumentsResponse', null, global);
goog.exportSymbol('proto.mw.customer.ValidateAddressRequest', null, global);
goog.exportSymbol('proto.mw.customer.ValidateAddressResponse', null, global);
goog.exportSymbol('proto.mw.customer.ValidateMiniShopOrderRequest', null, global);
goog.exportSymbol('proto.mw.customer.ValidateMiniShopOrderResponse', null, global);
goog.exportSymbol('proto.mw.customer.VerifyStudentEmailRequest', null, global);
goog.exportSymbol('proto.mw.customer.VerifyStudentEmailResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.AuthenticateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.AuthenticateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.AuthenticateRequest.displayName = 'proto.mw.customer.AuthenticateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.AuthenticateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.AuthenticateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.AuthenticateResponse.displayName = 'proto.mw.customer.AuthenticateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.RequestNewPasswordTokenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.RequestNewPasswordTokenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.RequestNewPasswordTokenRequest.displayName = 'proto.mw.customer.RequestNewPasswordTokenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.RequestNewPasswordTokenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.RequestNewPasswordTokenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.RequestNewPasswordTokenResponse.displayName = 'proto.mw.customer.RequestNewPasswordTokenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SaveNewPasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SaveNewPasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SaveNewPasswordRequest.displayName = 'proto.mw.customer.SaveNewPasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SaveNewPasswordResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SaveNewPasswordResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SaveNewPasswordResponse.displayName = 'proto.mw.customer.SaveNewPasswordResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ContactFormValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ContactFormValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ContactFormValue.displayName = 'proto.mw.customer.ContactFormValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SubmitContactFormRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.SubmitContactFormRequest.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.SubmitContactFormRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SubmitContactFormRequest.displayName = 'proto.mw.customer.SubmitContactFormRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SubmitContactFormResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SubmitContactFormResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SubmitContactFormResponse.displayName = 'proto.mw.customer.SubmitContactFormResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrdersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetOrdersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrdersRequest.displayName = 'proto.mw.customer.GetOrdersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrdersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetOrdersResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetOrdersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrdersResponse.displayName = 'proto.mw.customer.GetOrdersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.CreateOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.CreateOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.CreateOrderRequest.displayName = 'proto.mw.customer.CreateOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.CreateOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.CreateOrderResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.CreateOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.CreateOrderResponse.displayName = 'proto.mw.customer.CreateOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SkippedOrderItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SkippedOrderItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SkippedOrderItem.displayName = 'proto.mw.customer.SkippedOrderItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrderSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetOrderSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrderSummaryRequest.displayName = 'proto.mw.customer.GetOrderSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrderSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetOrderSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrderSummaryResponse.displayName = 'proto.mw.customer.GetOrderSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ClearProductQuantitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ClearProductQuantitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ClearProductQuantitiesRequest.displayName = 'proto.mw.customer.ClearProductQuantitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ClearProductQuantitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ClearProductQuantitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ClearProductQuantitiesResponse.displayName = 'proto.mw.customer.ClearProductQuantitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.DownloadInvoicePDFRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.DownloadInvoicePDFRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.DownloadInvoicePDFRequest.displayName = 'proto.mw.customer.DownloadInvoicePDFRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.DownloadInvoicePDFResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.DownloadInvoicePDFResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.DownloadInvoicePDFResponse.displayName = 'proto.mw.customer.DownloadInvoicePDFResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrderFormV2Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetOrderFormV2Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrderFormV2Request.displayName = 'proto.mw.customer.GetOrderFormV2Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrderFormV2Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetOrderFormV2Response.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetOrderFormV2Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrderFormV2Response.displayName = 'proto.mw.customer.GetOrderFormV2Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrderFormV2GroupedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetOrderFormV2GroupedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrderFormV2GroupedRequest.displayName = 'proto.mw.customer.GetOrderFormV2GroupedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetOrderFormV2GroupedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetOrderFormV2GroupedResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetOrderFormV2GroupedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetOrderFormV2GroupedResponse.displayName = 'proto.mw.customer.GetOrderFormV2GroupedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetMiniShopRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetMiniShopRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetMiniShopRequest.displayName = 'proto.mw.customer.GetMiniShopRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetMiniShopResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetMiniShopResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetMiniShopResponse.displayName = 'proto.mw.customer.GetMiniShopResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ValidateMiniShopOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ValidateMiniShopOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ValidateMiniShopOrderRequest.displayName = 'proto.mw.customer.ValidateMiniShopOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ValidateMiniShopOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ValidateMiniShopOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ValidateMiniShopOrderResponse.displayName = 'proto.mw.customer.ValidateMiniShopOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.CreateMiniShopOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.CreateMiniShopOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.CreateMiniShopOrderRequest.displayName = 'proto.mw.customer.CreateMiniShopOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.CreateMiniShopOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.CreateMiniShopOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.CreateMiniShopOrderResponse.displayName = 'proto.mw.customer.CreateMiniShopOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.CaptureMiniShopOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.CaptureMiniShopOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.CaptureMiniShopOrderRequest.displayName = 'proto.mw.customer.CaptureMiniShopOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.CaptureMiniShopOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.CaptureMiniShopOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.CaptureMiniShopOrderResponse.displayName = 'proto.mw.customer.CaptureMiniShopOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ValidateAddressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ValidateAddressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ValidateAddressRequest.displayName = 'proto.mw.customer.ValidateAddressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ValidateAddressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ValidateAddressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ValidateAddressResponse.displayName = 'proto.mw.customer.ValidateAddressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.TrackUsageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.TrackUsageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.TrackUsageRequest.displayName = 'proto.mw.customer.TrackUsageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.TrackUsageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.TrackUsageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.TrackUsageResponse.displayName = 'proto.mw.customer.TrackUsageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ErrorRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ErrorRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ErrorRequest.displayName = 'proto.mw.customer.ErrorRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ErrorResponse.displayName = 'proto.mw.customer.ErrorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SkinAnalysisImageRequirement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SkinAnalysisImageRequirement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SkinAnalysisImageRequirement.displayName = 'proto.mw.customer.SkinAnalysisImageRequirement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SkinAnalysisSlider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SkinAnalysisSlider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SkinAnalysisSlider.displayName = 'proto.mw.customer.SkinAnalysisSlider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetSkinAnalysisFormRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetSkinAnalysisFormRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetSkinAnalysisFormRequest.displayName = 'proto.mw.customer.GetSkinAnalysisFormRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetSkinAnalysisFormResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetSkinAnalysisFormResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetSkinAnalysisFormResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetSkinAnalysisFormResponse.displayName = 'proto.mw.customer.GetSkinAnalysisFormResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SkinImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SkinImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SkinImage.displayName = 'proto.mw.customer.SkinImage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.AnalyzeSkinProblemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.AnalyzeSkinProblemsRequest.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.AnalyzeSkinProblemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.AnalyzeSkinProblemsRequest.displayName = 'proto.mw.customer.AnalyzeSkinProblemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.SkinProblemScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.SkinProblemScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.SkinProblemScore.displayName = 'proto.mw.customer.SkinProblemScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.AnalyzeSkinProblemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.AnalyzeSkinProblemsResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.AnalyzeSkinProblemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.AnalyzeSkinProblemsResponse.displayName = 'proto.mw.customer.AnalyzeSkinProblemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetProductRecommendationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetProductRecommendationsRequest.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetProductRecommendationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetProductRecommendationsRequest.displayName = 'proto.mw.customer.GetProductRecommendationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ProductRecommendation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.ProductRecommendation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ProductRecommendation.displayName = 'proto.mw.customer.ProductRecommendation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetProductRecommendationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetProductRecommendationsResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetProductRecommendationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetProductRecommendationsResponse.displayName = 'proto.mw.customer.GetProductRecommendationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetSkinProblemsForAnalysisRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetSkinProblemsForAnalysisRequest.displayName = 'proto.mw.customer.GetSkinProblemsForAnalysisRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetSkinProblemsForAnalysisResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetSkinProblemsForAnalysisResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetSkinProblemsForAnalysisResponse.displayName = 'proto.mw.customer.GetSkinProblemsForAnalysisResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.AnalyzeSkinImagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.AnalyzeSkinImagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.AnalyzeSkinImagesRequest.displayName = 'proto.mw.customer.AnalyzeSkinImagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.AnalyzeSkinImagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.AnalyzeSkinImagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.AnalyzeSkinImagesResponse.displayName = 'proto.mw.customer.AnalyzeSkinImagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetSuggestedProductsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetSuggestedProductsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetSuggestedProductsRequest.displayName = 'proto.mw.customer.GetSuggestedProductsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetSuggestedProductsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.GetSuggestedProductsResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.GetSuggestedProductsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetSuggestedProductsResponse.displayName = 'proto.mw.customer.GetSuggestedProductsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.ProductSkinProblems = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.ProductSkinProblems.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.ProductSkinProblems, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.ProductSkinProblems.displayName = 'proto.mw.customer.ProductSkinProblems';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.RegisterStudentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.RegisterStudentRequest.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.RegisterStudentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.RegisterStudentRequest.displayName = 'proto.mw.customer.RegisterStudentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.RegisterStudentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.RegisterStudentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.RegisterStudentResponse.displayName = 'proto.mw.customer.RegisterStudentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.VerifyStudentEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.VerifyStudentEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.VerifyStudentEmailRequest.displayName = 'proto.mw.customer.VerifyStudentEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.VerifyStudentEmailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.VerifyStudentEmailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.VerifyStudentEmailResponse.displayName = 'proto.mw.customer.VerifyStudentEmailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.StudentDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.StudentDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.StudentDocument.displayName = 'proto.mw.customer.StudentDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.UploadStudentDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.UploadStudentDocumentsRequest.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.UploadStudentDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.UploadStudentDocumentsRequest.displayName = 'proto.mw.customer.UploadStudentDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.UploadStudentDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mw.customer.UploadStudentDocumentsResponse.repeatedFields_, null);
};
goog.inherits(proto.mw.customer.UploadStudentDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.UploadStudentDocumentsResponse.displayName = 'proto.mw.customer.UploadStudentDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetStudentStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetStudentStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetStudentStatusRequest.displayName = 'proto.mw.customer.GetStudentStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mw.customer.GetStudentStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mw.customer.GetStudentStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mw.customer.GetStudentStatusResponse.displayName = 'proto.mw.customer.GetStudentStatusResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.AuthenticateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.AuthenticateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.AuthenticateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AuthenticateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
password: jspb.Message.getFieldWithDefault(msg, 2, ""),
authToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
userAgent: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.AuthenticateRequest}
 */
proto.mw.customer.AuthenticateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.AuthenticateRequest;
  return proto.mw.customer.AuthenticateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.AuthenticateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.AuthenticateRequest}
 */
proto.mw.customer.AuthenticateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserAgent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.AuthenticateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.AuthenticateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.AuthenticateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AuthenticateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserAgent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.mw.customer.AuthenticateRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AuthenticateRequest} returns this
 */
proto.mw.customer.AuthenticateRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.mw.customer.AuthenticateRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AuthenticateRequest} returns this
 */
proto.mw.customer.AuthenticateRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string auth_token = 3;
 * @return {string}
 */
proto.mw.customer.AuthenticateRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AuthenticateRequest} returns this
 */
proto.mw.customer.AuthenticateRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_agent = 4;
 * @return {string}
 */
proto.mw.customer.AuthenticateRequest.prototype.getUserAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AuthenticateRequest} returns this
 */
proto.mw.customer.AuthenticateRequest.prototype.setUserAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.AuthenticateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.AuthenticateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.AuthenticateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AuthenticateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
customer: (f = msg.getCustomer()) && common_common_pb.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.AuthenticateResponse}
 */
proto.mw.customer.AuthenticateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.AuthenticateResponse;
  return proto.mw.customer.AuthenticateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.AuthenticateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.AuthenticateResponse}
 */
proto.mw.customer.AuthenticateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = new common_common_pb.Customer;
      reader.readMessage(value,common_common_pb.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.AuthenticateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.AuthenticateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.AuthenticateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AuthenticateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.AuthenticateResponse.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AuthenticateResponse} returns this
 */
proto.mw.customer.AuthenticateResponse.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional mw.common.Customer customer = 2;
 * @return {?proto.mw.common.Customer}
 */
proto.mw.customer.AuthenticateResponse.prototype.getCustomer = function() {
  return /** @type{?proto.mw.common.Customer} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Customer, 2));
};


/**
 * @param {?proto.mw.common.Customer|undefined} value
 * @return {!proto.mw.customer.AuthenticateResponse} returns this
*/
proto.mw.customer.AuthenticateResponse.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.AuthenticateResponse} returns this
 */
proto.mw.customer.AuthenticateResponse.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.AuthenticateResponse.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.RequestNewPasswordTokenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.RequestNewPasswordTokenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.RequestNewPasswordTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RequestNewPasswordTokenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
emailAddress: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.RequestNewPasswordTokenRequest}
 */
proto.mw.customer.RequestNewPasswordTokenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.RequestNewPasswordTokenRequest;
  return proto.mw.customer.RequestNewPasswordTokenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.RequestNewPasswordTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.RequestNewPasswordTokenRequest}
 */
proto.mw.customer.RequestNewPasswordTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.RequestNewPasswordTokenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.RequestNewPasswordTokenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.RequestNewPasswordTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RequestNewPasswordTokenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email_address = 1;
 * @return {string}
 */
proto.mw.customer.RequestNewPasswordTokenRequest.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.RequestNewPasswordTokenRequest} returns this
 */
proto.mw.customer.RequestNewPasswordTokenRequest.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.RequestNewPasswordTokenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.RequestNewPasswordTokenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.RequestNewPasswordTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RequestNewPasswordTokenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.RequestNewPasswordTokenResponse}
 */
proto.mw.customer.RequestNewPasswordTokenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.RequestNewPasswordTokenResponse;
  return proto.mw.customer.RequestNewPasswordTokenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.RequestNewPasswordTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.RequestNewPasswordTokenResponse}
 */
proto.mw.customer.RequestNewPasswordTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.RequestNewPasswordTokenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.RequestNewPasswordTokenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.RequestNewPasswordTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RequestNewPasswordTokenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.RequestNewPasswordTokenResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.RequestNewPasswordTokenResponse} returns this
 */
proto.mw.customer.RequestNewPasswordTokenResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SaveNewPasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SaveNewPasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SaveNewPasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
newPasswordToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
authToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
newPassword: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SaveNewPasswordRequest}
 */
proto.mw.customer.SaveNewPasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SaveNewPasswordRequest;
  return proto.mw.customer.SaveNewPasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SaveNewPasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SaveNewPasswordRequest}
 */
proto.mw.customer.SaveNewPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPasswordToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SaveNewPasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SaveNewPasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SaveNewPasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewPasswordToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string new_password_token = 1;
 * @return {string}
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.getNewPasswordToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SaveNewPasswordRequest} returns this
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.setNewPasswordToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string auth_token = 2;
 * @return {string}
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SaveNewPasswordRequest} returns this
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string new_password = 3;
 * @return {string}
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SaveNewPasswordRequest} returns this
 */
proto.mw.customer.SaveNewPasswordRequest.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SaveNewPasswordResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SaveNewPasswordResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SaveNewPasswordResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SaveNewPasswordResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
authToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SaveNewPasswordResponse}
 */
proto.mw.customer.SaveNewPasswordResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SaveNewPasswordResponse;
  return proto.mw.customer.SaveNewPasswordResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SaveNewPasswordResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SaveNewPasswordResponse}
 */
proto.mw.customer.SaveNewPasswordResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SaveNewPasswordResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SaveNewPasswordResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SaveNewPasswordResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SaveNewPasswordResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.SaveNewPasswordResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.SaveNewPasswordResponse} returns this
 */
proto.mw.customer.SaveNewPasswordResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string auth_token = 2;
 * @return {string}
 */
proto.mw.customer.SaveNewPasswordResponse.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SaveNewPasswordResponse} returns this
 */
proto.mw.customer.SaveNewPasswordResponse.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ContactFormValue.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ContactFormValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ContactFormValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ContactFormValue.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ContactFormValue}
 */
proto.mw.customer.ContactFormValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ContactFormValue;
  return proto.mw.customer.ContactFormValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ContactFormValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ContactFormValue}
 */
proto.mw.customer.ContactFormValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ContactFormValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ContactFormValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ContactFormValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ContactFormValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.mw.customer.ContactFormValue.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ContactFormValue} returns this
 */
proto.mw.customer.ContactFormValue.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.mw.customer.ContactFormValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ContactFormValue} returns this
 */
proto.mw.customer.ContactFormValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.SubmitContactFormRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SubmitContactFormRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SubmitContactFormRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SubmitContactFormRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SubmitContactFormRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
contactFormValuesList: jspb.Message.toObjectList(msg.getContactFormValuesList(),
    proto.mw.customer.ContactFormValue.toObject, includeInstance),
formType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SubmitContactFormRequest}
 */
proto.mw.customer.SubmitContactFormRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SubmitContactFormRequest;
  return proto.mw.customer.SubmitContactFormRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SubmitContactFormRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SubmitContactFormRequest}
 */
proto.mw.customer.SubmitContactFormRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.mw.customer.ContactFormValue;
      reader.readMessage(value,proto.mw.customer.ContactFormValue.deserializeBinaryFromReader);
      msg.addContactFormValues(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SubmitContactFormRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SubmitContactFormRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SubmitContactFormRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SubmitContactFormRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContactFormValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.customer.ContactFormValue.serializeBinaryToWriter
    );
  }
  f = message.getFormType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated ContactFormValue contact_form_values = 2;
 * @return {!Array<!proto.mw.customer.ContactFormValue>}
 */
proto.mw.customer.SubmitContactFormRequest.prototype.getContactFormValuesList = function() {
  return /** @type{!Array<!proto.mw.customer.ContactFormValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.ContactFormValue, 2));
};


/**
 * @param {!Array<!proto.mw.customer.ContactFormValue>} value
 * @return {!proto.mw.customer.SubmitContactFormRequest} returns this
*/
proto.mw.customer.SubmitContactFormRequest.prototype.setContactFormValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.customer.ContactFormValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.ContactFormValue}
 */
proto.mw.customer.SubmitContactFormRequest.prototype.addContactFormValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.customer.ContactFormValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.SubmitContactFormRequest} returns this
 */
proto.mw.customer.SubmitContactFormRequest.prototype.clearContactFormValuesList = function() {
  return this.setContactFormValuesList([]);
};


/**
 * optional string form_type = 3;
 * @return {string}
 */
proto.mw.customer.SubmitContactFormRequest.prototype.getFormType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SubmitContactFormRequest} returns this
 */
proto.mw.customer.SubmitContactFormRequest.prototype.setFormType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SubmitContactFormResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SubmitContactFormResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SubmitContactFormResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SubmitContactFormResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SubmitContactFormResponse}
 */
proto.mw.customer.SubmitContactFormResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SubmitContactFormResponse;
  return proto.mw.customer.SubmitContactFormResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SubmitContactFormResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SubmitContactFormResponse}
 */
proto.mw.customer.SubmitContactFormResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SubmitContactFormResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SubmitContactFormResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SubmitContactFormResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SubmitContactFormResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.SubmitContactFormResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.SubmitContactFormResponse} returns this
 */
proto.mw.customer.SubmitContactFormResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrdersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrdersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrdersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrdersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrdersRequest}
 */
proto.mw.customer.GetOrdersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrdersRequest;
  return proto.mw.customer.GetOrdersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrdersRequest}
 */
proto.mw.customer.GetOrdersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrdersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrdersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrdersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.GetOrdersRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrdersRequest} returns this
 */
proto.mw.customer.GetOrdersRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetOrdersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrdersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrdersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrdersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrdersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    common_common_pb.Order.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrdersResponse}
 */
proto.mw.customer.GetOrdersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrdersResponse;
  return proto.mw.customer.GetOrdersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrdersResponse}
 */
proto.mw.customer.GetOrdersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.Order;
      reader.readMessage(value,common_common_pb.Order.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrdersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrdersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_common_pb.Order.serializeBinaryToWriter
    );
  }
};


/**
 * repeated mw.common.Order orders = 1;
 * @return {!Array<!proto.mw.common.Order>}
 */
proto.mw.customer.GetOrdersResponse.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.mw.common.Order>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_common_pb.Order, 1));
};


/**
 * @param {!Array<!proto.mw.common.Order>} value
 * @return {!proto.mw.customer.GetOrdersResponse} returns this
*/
proto.mw.customer.GetOrdersResponse.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.Order=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.Order}
 */
proto.mw.customer.GetOrdersResponse.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.Order, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetOrdersResponse} returns this
 */
proto.mw.customer.GetOrdersResponse.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.CreateOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.CreateOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.CreateOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
note: jspb.Message.getFieldWithDefault(msg, 2, ""),
productQuantitiesMap: (f = msg.getProductQuantitiesMap()) ? f.toObject(includeInstance, undefined) : [],
deliveryAddress: (f = msg.getDeliveryAddress()) && common_common_pb.Address.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.CreateOrderRequest}
 */
proto.mw.customer.CreateOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.CreateOrderRequest;
  return proto.mw.customer.CreateOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.CreateOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.CreateOrderRequest}
 */
proto.mw.customer.CreateOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 3:
      var value = msg.getProductQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 4:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setDeliveryAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.CreateOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.CreateOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.CreateOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDeliveryAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.CreateOrderRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateOrderRequest} returns this
 */
proto.mw.customer.CreateOrderRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string note = 2;
 * @return {string}
 */
proto.mw.customer.CreateOrderRequest.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateOrderRequest} returns this
 */
proto.mw.customer.CreateOrderRequest.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> product_quantities = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.customer.CreateOrderRequest.prototype.getProductQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.CreateOrderRequest} returns this
 */
proto.mw.customer.CreateOrderRequest.prototype.clearProductQuantitiesMap = function() {
  this.getProductQuantitiesMap().clear();
  return this;
};


/**
 * optional mw.common.Address delivery_address = 4;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.CreateOrderRequest.prototype.getDeliveryAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 4));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.CreateOrderRequest} returns this
*/
proto.mw.customer.CreateOrderRequest.prototype.setDeliveryAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.CreateOrderRequest} returns this
 */
proto.mw.customer.CreateOrderRequest.prototype.clearDeliveryAddress = function() {
  return this.setDeliveryAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.CreateOrderRequest.prototype.hasDeliveryAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.CreateOrderResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.CreateOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.CreateOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.CreateOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
order: (f = msg.getOrder()) && common_common_pb.Order.toObject(includeInstance, f),
skippedItemsList: jspb.Message.toObjectList(msg.getSkippedItemsList(),
    proto.mw.customer.SkippedOrderItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.CreateOrderResponse}
 */
proto.mw.customer.CreateOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.CreateOrderResponse;
  return proto.mw.customer.CreateOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.CreateOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.CreateOrderResponse}
 */
proto.mw.customer.CreateOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new common_common_pb.Order;
      reader.readMessage(value,common_common_pb.Order.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 3:
      var value = new proto.mw.customer.SkippedOrderItem;
      reader.readMessage(value,proto.mw.customer.SkippedOrderItem.deserializeBinaryFromReader);
      msg.addSkippedItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.CreateOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.CreateOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.CreateOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Order.serializeBinaryToWriter
    );
  }
  f = message.getSkippedItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.mw.customer.SkippedOrderItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.CreateOrderResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.CreateOrderResponse} returns this
 */
proto.mw.customer.CreateOrderResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional mw.common.Order order = 2;
 * @return {?proto.mw.common.Order}
 */
proto.mw.customer.CreateOrderResponse.prototype.getOrder = function() {
  return /** @type{?proto.mw.common.Order} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Order, 2));
};


/**
 * @param {?proto.mw.common.Order|undefined} value
 * @return {!proto.mw.customer.CreateOrderResponse} returns this
*/
proto.mw.customer.CreateOrderResponse.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.CreateOrderResponse} returns this
 */
proto.mw.customer.CreateOrderResponse.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.CreateOrderResponse.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated SkippedOrderItem skipped_items = 3;
 * @return {!Array<!proto.mw.customer.SkippedOrderItem>}
 */
proto.mw.customer.CreateOrderResponse.prototype.getSkippedItemsList = function() {
  return /** @type{!Array<!proto.mw.customer.SkippedOrderItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.SkippedOrderItem, 3));
};


/**
 * @param {!Array<!proto.mw.customer.SkippedOrderItem>} value
 * @return {!proto.mw.customer.CreateOrderResponse} returns this
*/
proto.mw.customer.CreateOrderResponse.prototype.setSkippedItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.mw.customer.SkippedOrderItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.SkippedOrderItem}
 */
proto.mw.customer.CreateOrderResponse.prototype.addSkippedItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.mw.customer.SkippedOrderItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.CreateOrderResponse} returns this
 */
proto.mw.customer.CreateOrderResponse.prototype.clearSkippedItemsList = function() {
  return this.setSkippedItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SkippedOrderItem.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SkippedOrderItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SkippedOrderItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkippedOrderItem.toObject = function(includeInstance, msg) {
  var f, obj = {
guid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SkippedOrderItem}
 */
proto.mw.customer.SkippedOrderItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SkippedOrderItem;
  return proto.mw.customer.SkippedOrderItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SkippedOrderItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SkippedOrderItem}
 */
proto.mw.customer.SkippedOrderItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SkippedOrderItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SkippedOrderItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SkippedOrderItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkippedOrderItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string guid = 1;
 * @return {string}
 */
proto.mw.customer.SkippedOrderItem.prototype.getGuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkippedOrderItem} returns this
 */
proto.mw.customer.SkippedOrderItem.prototype.setGuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.mw.customer.SkippedOrderItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkippedOrderItem} returns this
 */
proto.mw.customer.SkippedOrderItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.mw.customer.SkippedOrderItem.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkippedOrderItem} returns this
 */
proto.mw.customer.SkippedOrderItem.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrderSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrderSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
productQuantitiesMap: (f = msg.getProductQuantitiesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrderSummaryRequest}
 */
proto.mw.customer.GetOrderSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrderSummaryRequest;
  return proto.mw.customer.GetOrderSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrderSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrderSummaryRequest}
 */
proto.mw.customer.GetOrderSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 3:
      var value = msg.getProductQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrderSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrderSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderSummaryRequest} returns this
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string order_id = 2;
 * @return {string}
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderSummaryRequest} returns this
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> product_quantities = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.getProductQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.GetOrderSummaryRequest} returns this
 */
proto.mw.customer.GetOrderSummaryRequest.prototype.clearProductQuantitiesMap = function() {
  this.getProductQuantitiesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrderSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrderSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrderSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
orderSummary: (f = msg.getOrderSummary()) && common_common_pb.OrderSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrderSummaryResponse}
 */
proto.mw.customer.GetOrderSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrderSummaryResponse;
  return proto.mw.customer.GetOrderSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrderSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrderSummaryResponse}
 */
proto.mw.customer.GetOrderSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.OrderSummary;
      reader.readMessage(value,common_common_pb.OrderSummary.deserializeBinaryFromReader);
      msg.setOrderSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrderSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrderSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrderSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_common_pb.OrderSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional mw.common.OrderSummary order_summary = 1;
 * @return {?proto.mw.common.OrderSummary}
 */
proto.mw.customer.GetOrderSummaryResponse.prototype.getOrderSummary = function() {
  return /** @type{?proto.mw.common.OrderSummary} */ (
    jspb.Message.getWrapperField(this, common_common_pb.OrderSummary, 1));
};


/**
 * @param {?proto.mw.common.OrderSummary|undefined} value
 * @return {!proto.mw.customer.GetOrderSummaryResponse} returns this
*/
proto.mw.customer.GetOrderSummaryResponse.prototype.setOrderSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.GetOrderSummaryResponse} returns this
 */
proto.mw.customer.GetOrderSummaryResponse.prototype.clearOrderSummary = function() {
  return this.setOrderSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.GetOrderSummaryResponse.prototype.hasOrderSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ClearProductQuantitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ClearProductQuantitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ClearProductQuantitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ClearProductQuantitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ClearProductQuantitiesRequest}
 */
proto.mw.customer.ClearProductQuantitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ClearProductQuantitiesRequest;
  return proto.mw.customer.ClearProductQuantitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ClearProductQuantitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ClearProductQuantitiesRequest}
 */
proto.mw.customer.ClearProductQuantitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ClearProductQuantitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ClearProductQuantitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ClearProductQuantitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ClearProductQuantitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.ClearProductQuantitiesRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ClearProductQuantitiesRequest} returns this
 */
proto.mw.customer.ClearProductQuantitiesRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ClearProductQuantitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ClearProductQuantitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ClearProductQuantitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ClearProductQuantitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ClearProductQuantitiesResponse}
 */
proto.mw.customer.ClearProductQuantitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ClearProductQuantitiesResponse;
  return proto.mw.customer.ClearProductQuantitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ClearProductQuantitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ClearProductQuantitiesResponse}
 */
proto.mw.customer.ClearProductQuantitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ClearProductQuantitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ClearProductQuantitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ClearProductQuantitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ClearProductQuantitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.DownloadInvoicePDFRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.DownloadInvoicePDFRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.DownloadInvoicePDFRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.DownloadInvoicePDFRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.DownloadInvoicePDFRequest}
 */
proto.mw.customer.DownloadInvoicePDFRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.DownloadInvoicePDFRequest;
  return proto.mw.customer.DownloadInvoicePDFRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.DownloadInvoicePDFRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.DownloadInvoicePDFRequest}
 */
proto.mw.customer.DownloadInvoicePDFRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.DownloadInvoicePDFRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.DownloadInvoicePDFRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.DownloadInvoicePDFRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.DownloadInvoicePDFRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.DownloadInvoicePDFRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.DownloadInvoicePDFRequest} returns this
 */
proto.mw.customer.DownloadInvoicePDFRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string order_id = 2;
 * @return {string}
 */
proto.mw.customer.DownloadInvoicePDFRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.DownloadInvoicePDFRequest} returns this
 */
proto.mw.customer.DownloadInvoicePDFRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.DownloadInvoicePDFResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.DownloadInvoicePDFResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.DownloadInvoicePDFResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: msg.getData_asB64(),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileExtension: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.DownloadInvoicePDFResponse}
 */
proto.mw.customer.DownloadInvoicePDFResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.DownloadInvoicePDFResponse;
  return proto.mw.customer.DownloadInvoicePDFResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.DownloadInvoicePDFResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.DownloadInvoicePDFResponse}
 */
proto.mw.customer.DownloadInvoicePDFResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileExtension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.DownloadInvoicePDFResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.DownloadInvoicePDFResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.DownloadInvoicePDFResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileExtension();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.mw.customer.DownloadInvoicePDFResponse} returns this
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.DownloadInvoicePDFResponse} returns this
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_extension = 3;
 * @return {string}
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.getFileExtension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.DownloadInvoicePDFResponse} returns this
 */
proto.mw.customer.DownloadInvoicePDFResponse.prototype.setFileExtension = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrderFormV2Request.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrderFormV2Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrderFormV2Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2Request.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderForm: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrderFormV2Request}
 */
proto.mw.customer.GetOrderFormV2Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrderFormV2Request;
  return proto.mw.customer.GetOrderFormV2Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrderFormV2Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrderFormV2Request}
 */
proto.mw.customer.GetOrderFormV2Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrderFormV2Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrderFormV2Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrderFormV2Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderForm();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.GetOrderFormV2Request.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderFormV2Request} returns this
 */
proto.mw.customer.GetOrderFormV2Request.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string order_form = 2;
 * @return {string}
 */
proto.mw.customer.GetOrderFormV2Request.prototype.getOrderForm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderFormV2Request} returns this
 */
proto.mw.customer.GetOrderFormV2Request.prototype.setOrderForm = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetOrderFormV2Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrderFormV2Response.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrderFormV2Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrderFormV2Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2Response.toObject = function(includeInstance, msg) {
  var f, obj = {
categoriesList: jspb.Message.toObjectList(msg.getCategoriesList(),
    common_common_pb.OrderFormV2Category.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrderFormV2Response}
 */
proto.mw.customer.GetOrderFormV2Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrderFormV2Response;
  return proto.mw.customer.GetOrderFormV2Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrderFormV2Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrderFormV2Response}
 */
proto.mw.customer.GetOrderFormV2Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.OrderFormV2Category;
      reader.readMessage(value,common_common_pb.OrderFormV2Category.deserializeBinaryFromReader);
      msg.addCategories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrderFormV2Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrderFormV2Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrderFormV2Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_common_pb.OrderFormV2Category.serializeBinaryToWriter
    );
  }
};


/**
 * repeated mw.common.OrderFormV2Category categories = 1;
 * @return {!Array<!proto.mw.common.OrderFormV2Category>}
 */
proto.mw.customer.GetOrderFormV2Response.prototype.getCategoriesList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormV2Category>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_common_pb.OrderFormV2Category, 1));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormV2Category>} value
 * @return {!proto.mw.customer.GetOrderFormV2Response} returns this
*/
proto.mw.customer.GetOrderFormV2Response.prototype.setCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.OrderFormV2Category=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2Category}
 */
proto.mw.customer.GetOrderFormV2Response.prototype.addCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.OrderFormV2Category, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetOrderFormV2Response} returns this
 */
proto.mw.customer.GetOrderFormV2Response.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrderFormV2GroupedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrderFormV2GroupedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderForm: jspb.Message.getFieldWithDefault(msg, 2, ""),
category: jspb.Message.getFieldWithDefault(msg, 3, ""),
screenSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrderFormV2GroupedRequest}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrderFormV2GroupedRequest;
  return proto.mw.customer.GetOrderFormV2GroupedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrderFormV2GroupedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrderFormV2GroupedRequest}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderForm(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScreenSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrderFormV2GroupedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrderFormV2GroupedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderForm();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getScreenSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderFormV2GroupedRequest} returns this
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string order_form = 2;
 * @return {string}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.getOrderForm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderFormV2GroupedRequest} returns this
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.setOrderForm = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetOrderFormV2GroupedRequest} returns this
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 screen_size = 4;
 * @return {number}
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.getScreenSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.GetOrderFormV2GroupedRequest} returns this
 */
proto.mw.customer.GetOrderFormV2GroupedRequest.prototype.setScreenSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetOrderFormV2GroupedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetOrderFormV2GroupedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
categoriesList: jspb.Message.toObjectList(msg.getCategoriesList(),
    common_common_pb.OrderFormV2CategoryGrouped.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetOrderFormV2GroupedResponse}
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetOrderFormV2GroupedResponse;
  return proto.mw.customer.GetOrderFormV2GroupedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetOrderFormV2GroupedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetOrderFormV2GroupedResponse}
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.OrderFormV2CategoryGrouped;
      reader.readMessage(value,common_common_pb.OrderFormV2CategoryGrouped.deserializeBinaryFromReader);
      msg.addCategories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetOrderFormV2GroupedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetOrderFormV2GroupedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_common_pb.OrderFormV2CategoryGrouped.serializeBinaryToWriter
    );
  }
};


/**
 * repeated mw.common.OrderFormV2CategoryGrouped categories = 1;
 * @return {!Array<!proto.mw.common.OrderFormV2CategoryGrouped>}
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.prototype.getCategoriesList = function() {
  return /** @type{!Array<!proto.mw.common.OrderFormV2CategoryGrouped>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_common_pb.OrderFormV2CategoryGrouped, 1));
};


/**
 * @param {!Array<!proto.mw.common.OrderFormV2CategoryGrouped>} value
 * @return {!proto.mw.customer.GetOrderFormV2GroupedResponse} returns this
*/
proto.mw.customer.GetOrderFormV2GroupedResponse.prototype.setCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.OrderFormV2CategoryGrouped=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.OrderFormV2CategoryGrouped}
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.prototype.addCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.OrderFormV2CategoryGrouped, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetOrderFormV2GroupedResponse} returns this
 */
proto.mw.customer.GetOrderFormV2GroupedResponse.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetMiniShopRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetMiniShopRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetMiniShopRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetMiniShopRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
shopName: jspb.Message.getFieldWithDefault(msg, 1, ""),
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
ref: jspb.Message.getFieldWithDefault(msg, 3, ""),
qr: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ua: jspb.Message.getFieldWithDefault(msg, 5, ""),
email: jspb.Message.getFieldWithDefault(msg, 6, ""),
fbclid: jspb.Message.getFieldWithDefault(msg, 7, ""),
gclid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetMiniShopRequest}
 */
proto.mw.customer.GetMiniShopRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetMiniShopRequest;
  return proto.mw.customer.GetMiniShopRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetMiniShopRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetMiniShopRequest}
 */
proto.mw.customer.GetMiniShopRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRef(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUa(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFbclid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGclid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetMiniShopRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetMiniShopRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetMiniShopRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetMiniShopRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQr();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUa();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFbclid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGclid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string shop_name = 1;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getShopName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setShopName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref = 3;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setRef = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool qr = 4;
 * @return {boolean}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getQr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setQr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string ua = 5;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getUa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setUa = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email = 6;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fbclid = 7;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getFbclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setFbclid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string gclid = 8;
 * @return {string}
 */
proto.mw.customer.GetMiniShopRequest.prototype.getGclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopRequest} returns this
 */
proto.mw.customer.GetMiniShopRequest.prototype.setGclid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetMiniShopResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetMiniShopResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetMiniShopResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetMiniShopResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
shop: (f = msg.getShop()) && common_common_pb.MiniShop.toObject(includeInstance, f),
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
remainingQuantitiesMap: (f = msg.getRemainingQuantitiesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetMiniShopResponse}
 */
proto.mw.customer.GetMiniShopResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetMiniShopResponse;
  return proto.mw.customer.GetMiniShopResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetMiniShopResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetMiniShopResponse}
 */
proto.mw.customer.GetMiniShopResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.MiniShop;
      reader.readMessage(value,common_common_pb.MiniShop.deserializeBinaryFromReader);
      msg.setShop(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = msg.getRemainingQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetMiniShopResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetMiniShopResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetMiniShopResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetMiniShopResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShop();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_common_pb.MiniShop.serializeBinaryToWriter
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRemainingQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * optional mw.common.MiniShop shop = 1;
 * @return {?proto.mw.common.MiniShop}
 */
proto.mw.customer.GetMiniShopResponse.prototype.getShop = function() {
  return /** @type{?proto.mw.common.MiniShop} */ (
    jspb.Message.getWrapperField(this, common_common_pb.MiniShop, 1));
};


/**
 * @param {?proto.mw.common.MiniShop|undefined} value
 * @return {!proto.mw.customer.GetMiniShopResponse} returns this
*/
proto.mw.customer.GetMiniShopResponse.prototype.setShop = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.GetMiniShopResponse} returns this
 */
proto.mw.customer.GetMiniShopResponse.prototype.clearShop = function() {
  return this.setShop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.GetMiniShopResponse.prototype.hasShop = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.GetMiniShopResponse.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetMiniShopResponse} returns this
 */
proto.mw.customer.GetMiniShopResponse.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, int32> remaining_quantities = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.customer.GetMiniShopResponse.prototype.getRemainingQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.GetMiniShopResponse} returns this
 */
proto.mw.customer.GetMiniShopResponse.prototype.clearRemainingQuantitiesMap = function() {
  this.getRemainingQuantitiesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ValidateMiniShopOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ValidateMiniShopOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateMiniShopOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
shopName: jspb.Message.getFieldWithDefault(msg, 1, ""),
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
ref: jspb.Message.getFieldWithDefault(msg, 3, ""),
qr: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ua: jspb.Message.getFieldWithDefault(msg, 5, ""),
quantitiesMap: (f = msg.getQuantitiesMap()) ? f.toObject(includeInstance, undefined) : [],
invoiceAddress: (f = msg.getInvoiceAddress()) && common_common_pb.Address.toObject(includeInstance, f),
deliveryAddress: (f = msg.getDeliveryAddress()) && common_common_pb.Address.toObject(includeInstance, f),
email: jspb.Message.getFieldWithDefault(msg, 9, ""),
fbclid: jspb.Message.getFieldWithDefault(msg, 10, ""),
gclid: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ValidateMiniShopOrderRequest;
  return proto.mw.customer.ValidateMiniShopOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ValidateMiniShopOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRef(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUa(value);
      break;
    case 6:
      var value = msg.getQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    case 7:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setInvoiceAddress(value);
      break;
    case 8:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setDeliveryAddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFbclid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setGclid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ValidateMiniShopOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ValidateMiniShopOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateMiniShopOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQr();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUa();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
  f = message.getInvoiceAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryAddress();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFbclid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getGclid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string shop_name = 1;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getShopName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setShopName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref = 3;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setRef = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool qr = 4;
 * @return {boolean}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getQr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setQr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string ua = 5;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getUa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setUa = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, int32> quantities = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.clearQuantitiesMap = function() {
  this.getQuantitiesMap().clear();
  return this;
};


/**
 * optional mw.common.Address invoice_address = 7;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getInvoiceAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 7));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
*/
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setInvoiceAddress = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.clearInvoiceAddress = function() {
  return this.setInvoiceAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.hasInvoiceAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional mw.common.Address delivery_address = 8;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getDeliveryAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 8));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
*/
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setDeliveryAddress = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.clearDeliveryAddress = function() {
  return this.setDeliveryAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.hasDeliveryAddress = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string email = 9;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string fbclid = 10;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getFbclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setFbclid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string gclid = 11;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.getGclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderRequest} returns this
 */
proto.mw.customer.ValidateMiniShopOrderRequest.prototype.setGclid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ValidateMiniShopOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ValidateMiniShopOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateMiniShopOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
messagesMap: (f = msg.getMessagesMap()) ? f.toObject(includeInstance, undefined) : [],
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalWithoutVat: jspb.Message.getFieldWithDefault(msg, 3, ""),
totalWithVat: jspb.Message.getFieldWithDefault(msg, 4, ""),
vatPercentage: jspb.Message.getFieldWithDefault(msg, 5, ""),
vatValue: jspb.Message.getFieldWithDefault(msg, 6, ""),
remainingQuantitiesMap: (f = msg.getRemainingQuantitiesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ValidateMiniShopOrderResponse;
  return proto.mw.customer.ValidateMiniShopOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ValidateMiniShopOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getMessagesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalWithoutVat(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalWithVat(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVatPercentage(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setVatValue(value);
      break;
    case 7:
      var value = msg.getRemainingQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ValidateMiniShopOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ValidateMiniShopOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateMiniShopOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalWithoutVat();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalWithVat();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVatPercentage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVatValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRemainingQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * map<string, string> messages = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getMessagesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.clearMessagesMap = function() {
  this.getMessagesMap().clear();
  return this;
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string total_without_vat = 3;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getTotalWithoutVat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.setTotalWithoutVat = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string total_with_vat = 4;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getTotalWithVat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.setTotalWithVat = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string vat_percentage = 5;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getVatPercentage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.setVatPercentage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string vat_value = 6;
 * @return {string}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getVatValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.setVatValue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * map<string, int32> remaining_quantities = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.getRemainingQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.ValidateMiniShopOrderResponse} returns this
 */
proto.mw.customer.ValidateMiniShopOrderResponse.prototype.clearRemainingQuantitiesMap = function() {
  this.getRemainingQuantitiesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.CreateMiniShopOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.CreateMiniShopOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateMiniShopOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
shopName: jspb.Message.getFieldWithDefault(msg, 1, ""),
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
ref: jspb.Message.getFieldWithDefault(msg, 3, ""),
qr: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ua: jspb.Message.getFieldWithDefault(msg, 5, ""),
quantitiesMap: (f = msg.getQuantitiesMap()) ? f.toObject(includeInstance, undefined) : [],
invoiceAddress: (f = msg.getInvoiceAddress()) && common_common_pb.Address.toObject(includeInstance, f),
deliveryAddress: (f = msg.getDeliveryAddress()) && common_common_pb.Address.toObject(includeInstance, f),
email: jspb.Message.getFieldWithDefault(msg, 9, ""),
consentsMap: (f = msg.getConsentsMap()) ? f.toObject(includeInstance, undefined) : [],
fbclid: jspb.Message.getFieldWithDefault(msg, 11, ""),
gclid: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest}
 */
proto.mw.customer.CreateMiniShopOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.CreateMiniShopOrderRequest;
  return proto.mw.customer.CreateMiniShopOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.CreateMiniShopOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest}
 */
proto.mw.customer.CreateMiniShopOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRef(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUa(value);
      break;
    case 6:
      var value = msg.getQuantitiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    case 7:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setInvoiceAddress(value);
      break;
    case 8:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setDeliveryAddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = msg.getConsentsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFbclid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setGclid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.CreateMiniShopOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.CreateMiniShopOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateMiniShopOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQr();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUa();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQuantitiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
  f = message.getInvoiceAddress();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryAddress();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getConsentsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getFbclid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getGclid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string shop_name = 1;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getShopName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setShopName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref = 3;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setRef = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool qr = 4;
 * @return {boolean}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getQr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setQr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string ua = 5;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getUa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setUa = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, int32> quantities = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getQuantitiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.clearQuantitiesMap = function() {
  this.getQuantitiesMap().clear();
  return this;
};


/**
 * optional mw.common.Address invoice_address = 7;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getInvoiceAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 7));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
*/
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setInvoiceAddress = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.clearInvoiceAddress = function() {
  return this.setInvoiceAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.hasInvoiceAddress = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional mw.common.Address delivery_address = 8;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getDeliveryAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 8));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
*/
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setDeliveryAddress = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.clearDeliveryAddress = function() {
  return this.setDeliveryAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.hasDeliveryAddress = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string email = 9;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * map<string, string> consents = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getConsentsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.clearConsentsMap = function() {
  this.getConsentsMap().clear();
  return this;
};


/**
 * optional string fbclid = 11;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getFbclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setFbclid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string gclid = 12;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.getGclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderRequest} returns this
 */
proto.mw.customer.CreateMiniShopOrderRequest.prototype.setGclid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.CreateMiniShopOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.CreateMiniShopOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateMiniShopOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
orderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paypalOrderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
messagesMap: (f = msg.getMessagesMap()) ? f.toObject(includeInstance, undefined) : [],
vid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.CreateMiniShopOrderResponse}
 */
proto.mw.customer.CreateMiniShopOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.CreateMiniShopOrderResponse;
  return proto.mw.customer.CreateMiniShopOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.CreateMiniShopOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.CreateMiniShopOrderResponse}
 */
proto.mw.customer.CreateMiniShopOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaypalOrderId(value);
      break;
    case 3:
      var value = msg.getMessagesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.CreateMiniShopOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.CreateMiniShopOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CreateMiniShopOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaypalOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessagesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderResponse} returns this
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string paypal_order_id = 2;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.getPaypalOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderResponse} returns this
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.setPaypalOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> messages = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.getMessagesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.CreateMiniShopOrderResponse} returns this
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.clearMessagesMap = function() {
  this.getMessagesMap().clear();
  return this;
};


/**
 * optional string vid = 4;
 * @return {string}
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CreateMiniShopOrderResponse} returns this
 */
proto.mw.customer.CreateMiniShopOrderResponse.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.CaptureMiniShopOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.CaptureMiniShopOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CaptureMiniShopOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
orderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
ref: jspb.Message.getFieldWithDefault(msg, 3, ""),
qr: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ua: jspb.Message.getFieldWithDefault(msg, 5, ""),
invoice: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
fbclid: jspb.Message.getFieldWithDefault(msg, 7, ""),
gclid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.CaptureMiniShopOrderRequest;
  return proto.mw.customer.CaptureMiniShopOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.CaptureMiniShopOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRef(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUa(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInvoice(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFbclid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGclid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.CaptureMiniShopOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.CaptureMiniShopOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CaptureMiniShopOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQr();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUa();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInvoice();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFbclid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGclid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref = 3;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setRef = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool qr = 4;
 * @return {boolean}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getQr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setQr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string ua = 5;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getUa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setUa = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool invoice = 6;
 * @return {boolean}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getInvoice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setInvoice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string fbclid = 7;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getFbclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setFbclid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string gclid = 8;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.getGclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderRequest} returns this
 */
proto.mw.customer.CaptureMiniShopOrderRequest.prototype.setGclid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.CaptureMiniShopOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.CaptureMiniShopOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.CaptureMiniShopOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CaptureMiniShopOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
vid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.CaptureMiniShopOrderResponse}
 */
proto.mw.customer.CaptureMiniShopOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.CaptureMiniShopOrderResponse;
  return proto.mw.customer.CaptureMiniShopOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.CaptureMiniShopOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.CaptureMiniShopOrderResponse}
 */
proto.mw.customer.CaptureMiniShopOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.CaptureMiniShopOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.CaptureMiniShopOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.CaptureMiniShopOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.CaptureMiniShopOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderResponse} returns this
 */
proto.mw.customer.CaptureMiniShopOrderResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.CaptureMiniShopOrderResponse.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.CaptureMiniShopOrderResponse} returns this
 */
proto.mw.customer.CaptureMiniShopOrderResponse.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ValidateAddressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ValidateAddressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ValidateAddressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateAddressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
address: (f = msg.getAddress()) && common_common_pb.Address.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ValidateAddressRequest}
 */
proto.mw.customer.ValidateAddressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ValidateAddressRequest;
  return proto.mw.customer.ValidateAddressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ValidateAddressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ValidateAddressRequest}
 */
proto.mw.customer.ValidateAddressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ValidateAddressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ValidateAddressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ValidateAddressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateAddressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
};


/**
 * optional mw.common.Address address = 1;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.ValidateAddressRequest.prototype.getAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 1));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.ValidateAddressRequest} returns this
*/
proto.mw.customer.ValidateAddressRequest.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.ValidateAddressRequest} returns this
 */
proto.mw.customer.ValidateAddressRequest.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.ValidateAddressRequest.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ValidateAddressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ValidateAddressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ValidateAddressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateAddressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
messagesMap: (f = msg.getMessagesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ValidateAddressResponse}
 */
proto.mw.customer.ValidateAddressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ValidateAddressResponse;
  return proto.mw.customer.ValidateAddressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ValidateAddressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ValidateAddressResponse}
 */
proto.mw.customer.ValidateAddressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getMessagesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ValidateAddressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ValidateAddressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ValidateAddressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ValidateAddressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> messages = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.mw.customer.ValidateAddressResponse.prototype.getMessagesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.ValidateAddressResponse} returns this
 */
proto.mw.customer.ValidateAddressResponse.prototype.clearMessagesMap = function() {
  this.getMessagesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.TrackUsageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.TrackUsageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.TrackUsageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.TrackUsageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
usageType: jspb.Message.getFieldWithDefault(msg, 1, 0),
vid: jspb.Message.getFieldWithDefault(msg, 2, ""),
ref: jspb.Message.getFieldWithDefault(msg, 3, ""),
qr: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ua: jspb.Message.getFieldWithDefault(msg, 5, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 6, ""),
fbclid: jspb.Message.getFieldWithDefault(msg, 7, ""),
gclid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.TrackUsageRequest}
 */
proto.mw.customer.TrackUsageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.TrackUsageRequest;
  return proto.mw.customer.TrackUsageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.TrackUsageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.TrackUsageRequest}
 */
proto.mw.customer.TrackUsageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.mw.common.UsageType} */ (reader.readEnum());
      msg.setUsageType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRef(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setQr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUa(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFbclid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGclid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.TrackUsageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.TrackUsageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.TrackUsageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.TrackUsageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsageType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRef();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQr();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUa();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFbclid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGclid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional mw.common.UsageType usage_type = 1;
 * @return {!proto.mw.common.UsageType}
 */
proto.mw.customer.TrackUsageRequest.prototype.getUsageType = function() {
  return /** @type {!proto.mw.common.UsageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.mw.common.UsageType} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setUsageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string vid = 2;
 * @return {string}
 */
proto.mw.customer.TrackUsageRequest.prototype.getVid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setVid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref = 3;
 * @return {string}
 */
proto.mw.customer.TrackUsageRequest.prototype.getRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setRef = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool qr = 4;
 * @return {boolean}
 */
proto.mw.customer.TrackUsageRequest.prototype.getQr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setQr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string ua = 5;
 * @return {string}
 */
proto.mw.customer.TrackUsageRequest.prototype.getUa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setUa = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string order_id = 6;
 * @return {string}
 */
proto.mw.customer.TrackUsageRequest.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fbclid = 7;
 * @return {string}
 */
proto.mw.customer.TrackUsageRequest.prototype.getFbclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setFbclid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string gclid = 8;
 * @return {string}
 */
proto.mw.customer.TrackUsageRequest.prototype.getGclid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.TrackUsageRequest} returns this
 */
proto.mw.customer.TrackUsageRequest.prototype.setGclid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.TrackUsageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.TrackUsageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.TrackUsageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.TrackUsageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.TrackUsageResponse}
 */
proto.mw.customer.TrackUsageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.TrackUsageResponse;
  return proto.mw.customer.TrackUsageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.TrackUsageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.TrackUsageResponse}
 */
proto.mw.customer.TrackUsageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.TrackUsageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.TrackUsageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.TrackUsageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.TrackUsageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ErrorRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ErrorRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ErrorRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ErrorRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
error: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ErrorRequest}
 */
proto.mw.customer.ErrorRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ErrorRequest;
  return proto.mw.customer.ErrorRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ErrorRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ErrorRequest}
 */
proto.mw.customer.ErrorRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ErrorRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ErrorRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ErrorRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ErrorRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string error = 1;
 * @return {string}
 */
proto.mw.customer.ErrorRequest.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.ErrorRequest} returns this
 */
proto.mw.customer.ErrorRequest.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ErrorResponse}
 */
proto.mw.customer.ErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ErrorResponse;
  return proto.mw.customer.ErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ErrorResponse}
 */
proto.mw.customer.ErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SkinAnalysisImageRequirement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SkinAnalysisImageRequirement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinAnalysisImageRequirement.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
labelEn: jspb.Message.getFieldWithDefault(msg, 2, ""),
labelDe: jspb.Message.getFieldWithDefault(msg, 3, ""),
descriptionEn: jspb.Message.getFieldWithDefault(msg, 4, ""),
descriptionDe: jspb.Message.getFieldWithDefault(msg, 5, ""),
required: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement}
 */
proto.mw.customer.SkinAnalysisImageRequirement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SkinAnalysisImageRequirement;
  return proto.mw.customer.SkinAnalysisImageRequirement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SkinAnalysisImageRequirement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement}
 */
proto.mw.customer.SkinAnalysisImageRequirement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelEn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelDe(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionEn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionDe(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SkinAnalysisImageRequirement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SkinAnalysisImageRequirement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinAnalysisImageRequirement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabelEn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabelDe();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescriptionEn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescriptionDe();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement} returns this
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label_en = 2;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.getLabelEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement} returns this
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.setLabelEn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string label_de = 3;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.getLabelDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement} returns this
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.setLabelDe = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description_en = 4;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.getDescriptionEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement} returns this
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.setDescriptionEn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description_de = 5;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.getDescriptionDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement} returns this
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.setDescriptionDe = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool required = 6;
 * @return {boolean}
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement} returns this
 */
proto.mw.customer.SkinAnalysisImageRequirement.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SkinAnalysisSlider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SkinAnalysisSlider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinAnalysisSlider.toObject = function(includeInstance, msg) {
  var f, obj = {
skinProblemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
labelEn: jspb.Message.getFieldWithDefault(msg, 2, ""),
labelDe: jspb.Message.getFieldWithDefault(msg, 3, ""),
descriptionEn: jspb.Message.getFieldWithDefault(msg, 4, ""),
descriptionDe: jspb.Message.getFieldWithDefault(msg, 5, ""),
defaultValue: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SkinAnalysisSlider}
 */
proto.mw.customer.SkinAnalysisSlider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SkinAnalysisSlider;
  return proto.mw.customer.SkinAnalysisSlider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SkinAnalysisSlider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SkinAnalysisSlider}
 */
proto.mw.customer.SkinAnalysisSlider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSkinProblemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelEn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelDe(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionEn(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptionDe(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDefaultValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SkinAnalysisSlider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SkinAnalysisSlider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinAnalysisSlider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkinProblemId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLabelEn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabelDe();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescriptionEn();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescriptionDe();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDefaultValue();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional uint32 skin_problem_id = 1;
 * @return {number}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.getSkinProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.SkinAnalysisSlider} returns this
 */
proto.mw.customer.SkinAnalysisSlider.prototype.setSkinProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string label_en = 2;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.getLabelEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisSlider} returns this
 */
proto.mw.customer.SkinAnalysisSlider.prototype.setLabelEn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string label_de = 3;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.getLabelDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisSlider} returns this
 */
proto.mw.customer.SkinAnalysisSlider.prototype.setLabelDe = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description_en = 4;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.getDescriptionEn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisSlider} returns this
 */
proto.mw.customer.SkinAnalysisSlider.prototype.setDescriptionEn = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description_de = 5;
 * @return {string}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.getDescriptionDe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinAnalysisSlider} returns this
 */
proto.mw.customer.SkinAnalysisSlider.prototype.setDescriptionDe = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 default_value = 6;
 * @return {number}
 */
proto.mw.customer.SkinAnalysisSlider.prototype.getDefaultValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.SkinAnalysisSlider} returns this
 */
proto.mw.customer.SkinAnalysisSlider.prototype.setDefaultValue = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetSkinAnalysisFormRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetSkinAnalysisFormRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetSkinAnalysisFormRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinAnalysisFormRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
language: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetSkinAnalysisFormRequest}
 */
proto.mw.customer.GetSkinAnalysisFormRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetSkinAnalysisFormRequest;
  return proto.mw.customer.GetSkinAnalysisFormRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetSkinAnalysisFormRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetSkinAnalysisFormRequest}
 */
proto.mw.customer.GetSkinAnalysisFormRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetSkinAnalysisFormRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetSkinAnalysisFormRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetSkinAnalysisFormRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinAnalysisFormRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string language = 1;
 * @return {string}
 */
proto.mw.customer.GetSkinAnalysisFormRequest.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetSkinAnalysisFormRequest} returns this
 */
proto.mw.customer.GetSkinAnalysisFormRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetSkinAnalysisFormResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetSkinAnalysisFormResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetSkinAnalysisFormResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinAnalysisFormResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
imageRequirementsList: jspb.Message.toObjectList(msg.getImageRequirementsList(),
    proto.mw.customer.SkinAnalysisImageRequirement.toObject, includeInstance),
userInputSlidersList: jspb.Message.toObjectList(msg.getUserInputSlidersList(),
    proto.mw.customer.SkinAnalysisSlider.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetSkinAnalysisFormResponse}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetSkinAnalysisFormResponse;
  return proto.mw.customer.GetSkinAnalysisFormResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetSkinAnalysisFormResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetSkinAnalysisFormResponse}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.customer.SkinAnalysisImageRequirement;
      reader.readMessage(value,proto.mw.customer.SkinAnalysisImageRequirement.deserializeBinaryFromReader);
      msg.addImageRequirements(value);
      break;
    case 2:
      var value = new proto.mw.customer.SkinAnalysisSlider;
      reader.readMessage(value,proto.mw.customer.SkinAnalysisSlider.deserializeBinaryFromReader);
      msg.addUserInputSliders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetSkinAnalysisFormResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetSkinAnalysisFormResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinAnalysisFormResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageRequirementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.customer.SkinAnalysisImageRequirement.serializeBinaryToWriter
    );
  }
  f = message.getUserInputSlidersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.customer.SkinAnalysisSlider.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SkinAnalysisImageRequirement image_requirements = 1;
 * @return {!Array<!proto.mw.customer.SkinAnalysisImageRequirement>}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.getImageRequirementsList = function() {
  return /** @type{!Array<!proto.mw.customer.SkinAnalysisImageRequirement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.SkinAnalysisImageRequirement, 1));
};


/**
 * @param {!Array<!proto.mw.customer.SkinAnalysisImageRequirement>} value
 * @return {!proto.mw.customer.GetSkinAnalysisFormResponse} returns this
*/
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.setImageRequirementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.customer.SkinAnalysisImageRequirement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.SkinAnalysisImageRequirement}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.addImageRequirements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.customer.SkinAnalysisImageRequirement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetSkinAnalysisFormResponse} returns this
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.clearImageRequirementsList = function() {
  return this.setImageRequirementsList([]);
};


/**
 * repeated SkinAnalysisSlider user_input_sliders = 2;
 * @return {!Array<!proto.mw.customer.SkinAnalysisSlider>}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.getUserInputSlidersList = function() {
  return /** @type{!Array<!proto.mw.customer.SkinAnalysisSlider>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.SkinAnalysisSlider, 2));
};


/**
 * @param {!Array<!proto.mw.customer.SkinAnalysisSlider>} value
 * @return {!proto.mw.customer.GetSkinAnalysisFormResponse} returns this
*/
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.setUserInputSlidersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.customer.SkinAnalysisSlider=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.SkinAnalysisSlider}
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.addUserInputSliders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.customer.SkinAnalysisSlider, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetSkinAnalysisFormResponse} returns this
 */
proto.mw.customer.GetSkinAnalysisFormResponse.prototype.clearUserInputSlidersList = function() {
  return this.setUserInputSlidersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SkinImage.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SkinImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SkinImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinImage.toObject = function(includeInstance, msg) {
  var f, obj = {
imageId: jspb.Message.getFieldWithDefault(msg, 1, ""),
imageData: msg.getImageData_asB64(),
mimeType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SkinImage}
 */
proto.mw.customer.SkinImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SkinImage;
  return proto.mw.customer.SkinImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SkinImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SkinImage}
 */
proto.mw.customer.SkinImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setImageData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SkinImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SkinImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SkinImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string image_id = 1;
 * @return {string}
 */
proto.mw.customer.SkinImage.prototype.getImageId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinImage} returns this
 */
proto.mw.customer.SkinImage.prototype.setImageId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes image_data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.mw.customer.SkinImage.prototype.getImageData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes image_data = 2;
 * This is a type-conversion wrapper around `getImageData()`
 * @return {string}
 */
proto.mw.customer.SkinImage.prototype.getImageData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getImageData()));
};


/**
 * optional bytes image_data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImageData()`
 * @return {!Uint8Array}
 */
proto.mw.customer.SkinImage.prototype.getImageData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getImageData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.mw.customer.SkinImage} returns this
 */
proto.mw.customer.SkinImage.prototype.setImageData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional string mime_type = 3;
 * @return {string}
 */
proto.mw.customer.SkinImage.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.SkinImage} returns this
 */
proto.mw.customer.SkinImage.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.AnalyzeSkinProblemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.AnalyzeSkinProblemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    proto.mw.customer.SkinImage.toObject, includeInstance),
userScoresMap: (f = msg.getUserScoresMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsRequest}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.AnalyzeSkinProblemsRequest;
  return proto.mw.customer.AnalyzeSkinProblemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.AnalyzeSkinProblemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsRequest}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.customer.SkinImage;
      reader.readMessage(value,proto.mw.customer.SkinImage.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    case 2:
      var value = msg.getUserScoresMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readUint32, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.AnalyzeSkinProblemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.AnalyzeSkinProblemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.customer.SkinImage.serializeBinaryToWriter
    );
  }
  f = message.getUserScoresMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * repeated SkinImage images = 1;
 * @return {!Array<!proto.mw.customer.SkinImage>}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.mw.customer.SkinImage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.SkinImage, 1));
};


/**
 * @param {!Array<!proto.mw.customer.SkinImage>} value
 * @return {!proto.mw.customer.AnalyzeSkinProblemsRequest} returns this
*/
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.setImagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.customer.SkinImage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.SkinImage}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.customer.SkinImage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsRequest} returns this
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.clearImagesList = function() {
  return this.setImagesList([]);
};


/**
 * map<uint32, uint32> user_scores = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.getUserScoresMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsRequest} returns this
 */
proto.mw.customer.AnalyzeSkinProblemsRequest.prototype.clearUserScoresMap = function() {
  this.getUserScoresMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.SkinProblemScore.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.SkinProblemScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.SkinProblemScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinProblemScore.toObject = function(includeInstance, msg) {
  var f, obj = {
skinProblemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
skinProblem: (f = msg.getSkinProblem()) && common_common_pb.SkinProblem.toObject(includeInstance, f),
aiScore: jspb.Message.getFieldWithDefault(msg, 3, 0),
userScore: jspb.Message.getFieldWithDefault(msg, 4, 0),
finalScore: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.SkinProblemScore}
 */
proto.mw.customer.SkinProblemScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.SkinProblemScore;
  return proto.mw.customer.SkinProblemScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.SkinProblemScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.SkinProblemScore}
 */
proto.mw.customer.SkinProblemScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSkinProblemId(value);
      break;
    case 2:
      var value = new common_common_pb.SkinProblem;
      reader.readMessage(value,common_common_pb.SkinProblem.deserializeBinaryFromReader);
      msg.setSkinProblem(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAiScore(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFinalScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.SkinProblemScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.SkinProblemScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.SkinProblemScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.SkinProblemScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkinProblemId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSkinProblem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.SkinProblem.serializeBinaryToWriter
    );
  }
  f = message.getAiScore();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getUserScore();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getFinalScore();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional uint32 skin_problem_id = 1;
 * @return {number}
 */
proto.mw.customer.SkinProblemScore.prototype.getSkinProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.SkinProblemScore} returns this
 */
proto.mw.customer.SkinProblemScore.prototype.setSkinProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional mw.common.SkinProblem skin_problem = 2;
 * @return {?proto.mw.common.SkinProblem}
 */
proto.mw.customer.SkinProblemScore.prototype.getSkinProblem = function() {
  return /** @type{?proto.mw.common.SkinProblem} */ (
    jspb.Message.getWrapperField(this, common_common_pb.SkinProblem, 2));
};


/**
 * @param {?proto.mw.common.SkinProblem|undefined} value
 * @return {!proto.mw.customer.SkinProblemScore} returns this
*/
proto.mw.customer.SkinProblemScore.prototype.setSkinProblem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.SkinProblemScore} returns this
 */
proto.mw.customer.SkinProblemScore.prototype.clearSkinProblem = function() {
  return this.setSkinProblem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.SkinProblemScore.prototype.hasSkinProblem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 ai_score = 3;
 * @return {number}
 */
proto.mw.customer.SkinProblemScore.prototype.getAiScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.SkinProblemScore} returns this
 */
proto.mw.customer.SkinProblemScore.prototype.setAiScore = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 user_score = 4;
 * @return {number}
 */
proto.mw.customer.SkinProblemScore.prototype.getUserScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.SkinProblemScore} returns this
 */
proto.mw.customer.SkinProblemScore.prototype.setUserScore = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 final_score = 5;
 * @return {number}
 */
proto.mw.customer.SkinProblemScore.prototype.getFinalScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.SkinProblemScore} returns this
 */
proto.mw.customer.SkinProblemScore.prototype.setFinalScore = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.AnalyzeSkinProblemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.AnalyzeSkinProblemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
problemScoresList: jspb.Message.toObjectList(msg.getProblemScoresList(),
    proto.mw.customer.SkinProblemScore.toObject, includeInstance),
analysisId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsResponse}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.AnalyzeSkinProblemsResponse;
  return proto.mw.customer.AnalyzeSkinProblemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.AnalyzeSkinProblemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsResponse}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.customer.SkinProblemScore;
      reader.readMessage(value,proto.mw.customer.SkinProblemScore.deserializeBinaryFromReader);
      msg.addProblemScores(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnalysisId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.AnalyzeSkinProblemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.AnalyzeSkinProblemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.customer.SkinProblemScore.serializeBinaryToWriter
    );
  }
  f = message.getAnalysisId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated SkinProblemScore problem_scores = 1;
 * @return {!Array<!proto.mw.customer.SkinProblemScore>}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.getProblemScoresList = function() {
  return /** @type{!Array<!proto.mw.customer.SkinProblemScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.SkinProblemScore, 1));
};


/**
 * @param {!Array<!proto.mw.customer.SkinProblemScore>} value
 * @return {!proto.mw.customer.AnalyzeSkinProblemsResponse} returns this
*/
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.setProblemScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.customer.SkinProblemScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.SkinProblemScore}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.addProblemScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.customer.SkinProblemScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.AnalyzeSkinProblemsResponse} returns this
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.clearProblemScoresList = function() {
  return this.setProblemScoresList([]);
};


/**
 * optional string analysis_id = 2;
 * @return {string}
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.getAnalysisId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AnalyzeSkinProblemsResponse} returns this
 */
proto.mw.customer.AnalyzeSkinProblemsResponse.prototype.setAnalysisId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetProductRecommendationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetProductRecommendationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetProductRecommendationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetProductRecommendationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
problemScoresList: jspb.Message.toObjectList(msg.getProblemScoresList(),
    proto.mw.customer.SkinProblemScore.toObject, includeInstance),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetProductRecommendationsRequest}
 */
proto.mw.customer.GetProductRecommendationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetProductRecommendationsRequest;
  return proto.mw.customer.GetProductRecommendationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetProductRecommendationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetProductRecommendationsRequest}
 */
proto.mw.customer.GetProductRecommendationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.customer.SkinProblemScore;
      reader.readMessage(value,proto.mw.customer.SkinProblemScore.deserializeBinaryFromReader);
      msg.addProblemScores(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetProductRecommendationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetProductRecommendationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetProductRecommendationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemScoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.customer.SkinProblemScore.serializeBinaryToWriter
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated SkinProblemScore problem_scores = 1;
 * @return {!Array<!proto.mw.customer.SkinProblemScore>}
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.getProblemScoresList = function() {
  return /** @type{!Array<!proto.mw.customer.SkinProblemScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.SkinProblemScore, 1));
};


/**
 * @param {!Array<!proto.mw.customer.SkinProblemScore>} value
 * @return {!proto.mw.customer.GetProductRecommendationsRequest} returns this
*/
proto.mw.customer.GetProductRecommendationsRequest.prototype.setProblemScoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.customer.SkinProblemScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.SkinProblemScore}
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.addProblemScores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.customer.SkinProblemScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetProductRecommendationsRequest} returns this
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.clearProblemScoresList = function() {
  return this.setProblemScoresList([]);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.GetProductRecommendationsRequest} returns this
 */
proto.mw.customer.GetProductRecommendationsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ProductRecommendation.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ProductRecommendation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ProductRecommendation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ProductRecommendation.toObject = function(includeInstance, msg) {
  var f, obj = {
product: (f = msg.getProduct()) && common_common_pb.Product.toObject(includeInstance, f),
effectivenessScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
problemScoresMap: (f = msg.getProblemScoresMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ProductRecommendation}
 */
proto.mw.customer.ProductRecommendation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ProductRecommendation;
  return proto.mw.customer.ProductRecommendation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ProductRecommendation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ProductRecommendation}
 */
proto.mw.customer.ProductRecommendation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.Product;
      reader.readMessage(value,common_common_pb.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEffectivenessScore(value);
      break;
    case 3:
      var value = msg.getProblemScoresMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readUint32, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ProductRecommendation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ProductRecommendation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ProductRecommendation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ProductRecommendation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_common_pb.Product.serializeBinaryToWriter
    );
  }
  f = message.getEffectivenessScore();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getProblemScoresMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * optional mw.common.Product product = 1;
 * @return {?proto.mw.common.Product}
 */
proto.mw.customer.ProductRecommendation.prototype.getProduct = function() {
  return /** @type{?proto.mw.common.Product} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Product, 1));
};


/**
 * @param {?proto.mw.common.Product|undefined} value
 * @return {!proto.mw.customer.ProductRecommendation} returns this
*/
proto.mw.customer.ProductRecommendation.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.ProductRecommendation} returns this
 */
proto.mw.customer.ProductRecommendation.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.ProductRecommendation.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float effectiveness_score = 2;
 * @return {number}
 */
proto.mw.customer.ProductRecommendation.prototype.getEffectivenessScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.ProductRecommendation} returns this
 */
proto.mw.customer.ProductRecommendation.prototype.setEffectivenessScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * map<uint32, uint32> problem_scores = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.mw.customer.ProductRecommendation.prototype.getProblemScoresMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.ProductRecommendation} returns this
 */
proto.mw.customer.ProductRecommendation.prototype.clearProblemScoresMap = function() {
  this.getProblemScoresMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetProductRecommendationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetProductRecommendationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetProductRecommendationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetProductRecommendationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetProductRecommendationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
recommendationsList: jspb.Message.toObjectList(msg.getRecommendationsList(),
    proto.mw.customer.ProductRecommendation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetProductRecommendationsResponse}
 */
proto.mw.customer.GetProductRecommendationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetProductRecommendationsResponse;
  return proto.mw.customer.GetProductRecommendationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetProductRecommendationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetProductRecommendationsResponse}
 */
proto.mw.customer.GetProductRecommendationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.mw.customer.ProductRecommendation;
      reader.readMessage(value,proto.mw.customer.ProductRecommendation.deserializeBinaryFromReader);
      msg.addRecommendations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetProductRecommendationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetProductRecommendationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetProductRecommendationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetProductRecommendationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecommendationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.mw.customer.ProductRecommendation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProductRecommendation recommendations = 1;
 * @return {!Array<!proto.mw.customer.ProductRecommendation>}
 */
proto.mw.customer.GetProductRecommendationsResponse.prototype.getRecommendationsList = function() {
  return /** @type{!Array<!proto.mw.customer.ProductRecommendation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.ProductRecommendation, 1));
};


/**
 * @param {!Array<!proto.mw.customer.ProductRecommendation>} value
 * @return {!proto.mw.customer.GetProductRecommendationsResponse} returns this
*/
proto.mw.customer.GetProductRecommendationsResponse.prototype.setRecommendationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.customer.ProductRecommendation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.ProductRecommendation}
 */
proto.mw.customer.GetProductRecommendationsResponse.prototype.addRecommendations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.customer.ProductRecommendation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetProductRecommendationsResponse} returns this
 */
proto.mw.customer.GetProductRecommendationsResponse.prototype.clearRecommendationsList = function() {
  return this.setRecommendationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetSkinProblemsForAnalysisRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisRequest}
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetSkinProblemsForAnalysisRequest;
  return proto.mw.customer.GetSkinProblemsForAnalysisRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisRequest}
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetSkinProblemsForAnalysisRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinProblemsForAnalysisRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetSkinProblemsForAnalysisResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
skinProblemsList: jspb.Message.toObjectList(msg.getSkinProblemsList(),
    common_common_pb.SkinProblem.toObject, includeInstance),
analysisPrompt: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisResponse}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetSkinProblemsForAnalysisResponse;
  return proto.mw.customer.GetSkinProblemsForAnalysisResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisResponse}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.SkinProblem;
      reader.readMessage(value,common_common_pb.SkinProblem.deserializeBinaryFromReader);
      msg.addSkinProblems(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnalysisPrompt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetSkinProblemsForAnalysisResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetSkinProblemsForAnalysisResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkinProblemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_common_pb.SkinProblem.serializeBinaryToWriter
    );
  }
  f = message.getAnalysisPrompt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated mw.common.SkinProblem skin_problems = 1;
 * @return {!Array<!proto.mw.common.SkinProblem>}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.getSkinProblemsList = function() {
  return /** @type{!Array<!proto.mw.common.SkinProblem>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_common_pb.SkinProblem, 1));
};


/**
 * @param {!Array<!proto.mw.common.SkinProblem>} value
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisResponse} returns this
*/
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.setSkinProblemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.SkinProblem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.SkinProblem}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.addSkinProblems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.SkinProblem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisResponse} returns this
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.clearSkinProblemsList = function() {
  return this.setSkinProblemsList([]);
};


/**
 * optional string analysis_prompt = 2;
 * @return {string}
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.getAnalysisPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetSkinProblemsForAnalysisResponse} returns this
 */
proto.mw.customer.GetSkinProblemsForAnalysisResponse.prototype.setAnalysisPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.AnalyzeSkinImagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.AnalyzeSkinImagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.AnalyzeSkinImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinImagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
imagesMap: (f = msg.getImagesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.AnalyzeSkinImagesRequest}
 */
proto.mw.customer.AnalyzeSkinImagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.AnalyzeSkinImagesRequest;
  return proto.mw.customer.AnalyzeSkinImagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.AnalyzeSkinImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.AnalyzeSkinImagesRequest}
 */
proto.mw.customer.AnalyzeSkinImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getImagesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readBytes, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.AnalyzeSkinImagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.AnalyzeSkinImagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.AnalyzeSkinImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinImagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImagesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeBytes);
  }
};


/**
 * map<string, bytes> images = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!(string|Uint8Array)>}
 */
proto.mw.customer.AnalyzeSkinImagesRequest.prototype.getImagesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!(string|Uint8Array)>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.AnalyzeSkinImagesRequest} returns this
 */
proto.mw.customer.AnalyzeSkinImagesRequest.prototype.clearImagesMap = function() {
  this.getImagesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.AnalyzeSkinImagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.AnalyzeSkinImagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.AnalyzeSkinImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinImagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
analysisResultsMap: (f = msg.getAnalysisResultsMap()) ? f.toObject(includeInstance, undefined) : [],
analysisId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.AnalyzeSkinImagesResponse}
 */
proto.mw.customer.AnalyzeSkinImagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.AnalyzeSkinImagesResponse;
  return proto.mw.customer.AnalyzeSkinImagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.AnalyzeSkinImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.AnalyzeSkinImagesResponse}
 */
proto.mw.customer.AnalyzeSkinImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getAnalysisResultsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readUint32, null, 0, 0);
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnalysisId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.AnalyzeSkinImagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.AnalyzeSkinImagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.AnalyzeSkinImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.AnalyzeSkinImagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnalysisResultsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getAnalysisId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * map<uint32, uint32> analysis_results = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.mw.customer.AnalyzeSkinImagesResponse.prototype.getAnalysisResultsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.AnalyzeSkinImagesResponse} returns this
 */
proto.mw.customer.AnalyzeSkinImagesResponse.prototype.clearAnalysisResultsMap = function() {
  this.getAnalysisResultsMap().clear();
  return this;
};


/**
 * optional string analysis_id = 2;
 * @return {string}
 */
proto.mw.customer.AnalyzeSkinImagesResponse.prototype.getAnalysisId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.AnalyzeSkinImagesResponse} returns this
 */
proto.mw.customer.AnalyzeSkinImagesResponse.prototype.setAnalysisId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetSuggestedProductsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetSuggestedProductsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetSuggestedProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSuggestedProductsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
skinScoresMap: (f = msg.getSkinScoresMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetSuggestedProductsRequest}
 */
proto.mw.customer.GetSuggestedProductsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetSuggestedProductsRequest;
  return proto.mw.customer.GetSuggestedProductsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetSuggestedProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetSuggestedProductsRequest}
 */
proto.mw.customer.GetSuggestedProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getSkinScoresMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readUint32, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetSuggestedProductsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetSuggestedProductsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetSuggestedProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSuggestedProductsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkinScoresMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * map<uint32, uint32> skin_scores = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.mw.customer.GetSuggestedProductsRequest.prototype.getSkinScoresMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.GetSuggestedProductsRequest} returns this
 */
proto.mw.customer.GetSuggestedProductsRequest.prototype.clearSkinScoresMap = function() {
  this.getSkinScoresMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.GetSuggestedProductsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetSuggestedProductsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetSuggestedProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSuggestedProductsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
productsList: jspb.Message.toObjectList(msg.getProductsList(),
    common_common_pb.Product.toObject, includeInstance),
effectivenessScoresMap: (f = msg.getEffectivenessScoresMap()) ? f.toObject(includeInstance, undefined) : [],
productSkinProblemsMap: (f = msg.getProductSkinProblemsMap()) ? f.toObject(includeInstance, proto.mw.customer.ProductSkinProblems.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetSuggestedProductsResponse}
 */
proto.mw.customer.GetSuggestedProductsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetSuggestedProductsResponse;
  return proto.mw.customer.GetSuggestedProductsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetSuggestedProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetSuggestedProductsResponse}
 */
proto.mw.customer.GetSuggestedProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.Product;
      reader.readMessage(value,common_common_pb.Product.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 2:
      var value = msg.getEffectivenessScoresMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 3:
      var value = msg.getProductSkinProblemsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.mw.customer.ProductSkinProblems.deserializeBinaryFromReader, "", new proto.mw.customer.ProductSkinProblems());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetSuggestedProductsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetSuggestedProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetSuggestedProductsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_common_pb.Product.serializeBinaryToWriter
    );
  }
  f = message.getEffectivenessScoresMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getProductSkinProblemsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.mw.customer.ProductSkinProblems.serializeBinaryToWriter);
  }
};


/**
 * repeated mw.common.Product products = 1;
 * @return {!Array<!proto.mw.common.Product>}
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.mw.common.Product>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_common_pb.Product, 1));
};


/**
 * @param {!Array<!proto.mw.common.Product>} value
 * @return {!proto.mw.customer.GetSuggestedProductsResponse} returns this
*/
proto.mw.customer.GetSuggestedProductsResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.mw.common.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.common.Product}
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.mw.common.Product, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.GetSuggestedProductsResponse} returns this
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * map<string, uint32> effectiveness_scores = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.getEffectivenessScoresMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.GetSuggestedProductsResponse} returns this
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.clearEffectivenessScoresMap = function() {
  this.getEffectivenessScoresMap().clear();
  return this;
};


/**
 * map<string, ProductSkinProblems> product_skin_problems = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.mw.customer.ProductSkinProblems>}
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.getProductSkinProblemsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.mw.customer.ProductSkinProblems>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.mw.customer.ProductSkinProblems));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.GetSuggestedProductsResponse} returns this
 */
proto.mw.customer.GetSuggestedProductsResponse.prototype.clearProductSkinProblemsMap = function() {
  this.getProductSkinProblemsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.ProductSkinProblems.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.ProductSkinProblems.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.ProductSkinProblems.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.ProductSkinProblems} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ProductSkinProblems.toObject = function(includeInstance, msg) {
  var f, obj = {
skinProblemIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
problemEffectivenessMap: (f = msg.getProblemEffectivenessMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.ProductSkinProblems}
 */
proto.mw.customer.ProductSkinProblems.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.ProductSkinProblems;
  return proto.mw.customer.ProductSkinProblems.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.ProductSkinProblems} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.ProductSkinProblems}
 */
proto.mw.customer.ProductSkinProblems.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSkinProblemIds(values[i]);
      }
      break;
    case 2:
      var value = msg.getProblemEffectivenessMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readUint32, jspb.BinaryReader.prototype.readUint32, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.ProductSkinProblems.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.ProductSkinProblems.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.ProductSkinProblems} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.ProductSkinProblems.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkinProblemIdsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      1,
      f
    );
  }
  f = message.getProblemEffectivenessMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeUint32, jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * repeated uint32 skin_problem_ids = 1;
 * @return {!Array<number>}
 */
proto.mw.customer.ProductSkinProblems.prototype.getSkinProblemIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.mw.customer.ProductSkinProblems} returns this
 */
proto.mw.customer.ProductSkinProblems.prototype.setSkinProblemIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.ProductSkinProblems} returns this
 */
proto.mw.customer.ProductSkinProblems.prototype.addSkinProblemIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.ProductSkinProblems} returns this
 */
proto.mw.customer.ProductSkinProblems.prototype.clearSkinProblemIdsList = function() {
  return this.setSkinProblemIdsList([]);
};


/**
 * map<uint32, uint32> problem_effectiveness = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.mw.customer.ProductSkinProblems.prototype.getProblemEffectivenessMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.mw.customer.ProductSkinProblems} returns this
 */
proto.mw.customer.ProductSkinProblems.prototype.clearProblemEffectivenessMap = function() {
  this.getProblemEffectivenessMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.RegisterStudentRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.RegisterStudentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.RegisterStudentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.RegisterStudentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RegisterStudentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
password: jspb.Message.getFieldWithDefault(msg, 2, ""),
billingAddress: (f = msg.getBillingAddress()) && common_common_pb.Address.toObject(includeInstance, f),
deliveryAddress: (f = msg.getDeliveryAddress()) && common_common_pb.Address.toObject(includeInstance, f),
documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.mw.customer.StudentDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.RegisterStudentRequest}
 */
proto.mw.customer.RegisterStudentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.RegisterStudentRequest;
  return proto.mw.customer.RegisterStudentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.RegisterStudentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.RegisterStudentRequest}
 */
proto.mw.customer.RegisterStudentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setBillingAddress(value);
      break;
    case 4:
      var value = new common_common_pb.Address;
      reader.readMessage(value,common_common_pb.Address.deserializeBinaryFromReader);
      msg.setDeliveryAddress(value);
      break;
    case 5:
      var value = new proto.mw.customer.StudentDocument;
      reader.readMessage(value,proto.mw.customer.StudentDocument.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.RegisterStudentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.RegisterStudentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.RegisterStudentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RegisterStudentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBillingAddress();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.mw.customer.StudentDocument.serializeBinaryToWriter
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.mw.customer.RegisterStudentRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
 */
proto.mw.customer.RegisterStudentRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.mw.customer.RegisterStudentRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
 */
proto.mw.customer.RegisterStudentRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional mw.common.Address billing_address = 3;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.RegisterStudentRequest.prototype.getBillingAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 3));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
*/
proto.mw.customer.RegisterStudentRequest.prototype.setBillingAddress = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
 */
proto.mw.customer.RegisterStudentRequest.prototype.clearBillingAddress = function() {
  return this.setBillingAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.RegisterStudentRequest.prototype.hasBillingAddress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional mw.common.Address delivery_address = 4;
 * @return {?proto.mw.common.Address}
 */
proto.mw.customer.RegisterStudentRequest.prototype.getDeliveryAddress = function() {
  return /** @type{?proto.mw.common.Address} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Address, 4));
};


/**
 * @param {?proto.mw.common.Address|undefined} value
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
*/
proto.mw.customer.RegisterStudentRequest.prototype.setDeliveryAddress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
 */
proto.mw.customer.RegisterStudentRequest.prototype.clearDeliveryAddress = function() {
  return this.setDeliveryAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mw.customer.RegisterStudentRequest.prototype.hasDeliveryAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated StudentDocument documents = 5;
 * @return {!Array<!proto.mw.customer.StudentDocument>}
 */
proto.mw.customer.RegisterStudentRequest.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.mw.customer.StudentDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.StudentDocument, 5));
};


/**
 * @param {!Array<!proto.mw.customer.StudentDocument>} value
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
*/
proto.mw.customer.RegisterStudentRequest.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.mw.customer.StudentDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.StudentDocument}
 */
proto.mw.customer.RegisterStudentRequest.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.mw.customer.StudentDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.RegisterStudentRequest} returns this
 */
proto.mw.customer.RegisterStudentRequest.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.RegisterStudentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.RegisterStudentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.RegisterStudentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RegisterStudentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
customerId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.RegisterStudentResponse}
 */
proto.mw.customer.RegisterStudentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.RegisterStudentResponse;
  return proto.mw.customer.RegisterStudentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.RegisterStudentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.RegisterStudentResponse}
 */
proto.mw.customer.RegisterStudentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.RegisterStudentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.RegisterStudentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.RegisterStudentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.RegisterStudentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.RegisterStudentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.RegisterStudentResponse} returns this
 */
proto.mw.customer.RegisterStudentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.mw.customer.RegisterStudentResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.RegisterStudentResponse} returns this
 */
proto.mw.customer.RegisterStudentResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 customer_id = 3;
 * @return {number}
 */
proto.mw.customer.RegisterStudentResponse.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.RegisterStudentResponse} returns this
 */
proto.mw.customer.RegisterStudentResponse.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.VerifyStudentEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.VerifyStudentEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.VerifyStudentEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.VerifyStudentEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.VerifyStudentEmailRequest}
 */
proto.mw.customer.VerifyStudentEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.VerifyStudentEmailRequest;
  return proto.mw.customer.VerifyStudentEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.VerifyStudentEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.VerifyStudentEmailRequest}
 */
proto.mw.customer.VerifyStudentEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.VerifyStudentEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.VerifyStudentEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.VerifyStudentEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.VerifyStudentEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.mw.customer.VerifyStudentEmailRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.VerifyStudentEmailRequest} returns this
 */
proto.mw.customer.VerifyStudentEmailRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.VerifyStudentEmailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.VerifyStudentEmailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.VerifyStudentEmailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.VerifyStudentEmailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.VerifyStudentEmailResponse}
 */
proto.mw.customer.VerifyStudentEmailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.VerifyStudentEmailResponse;
  return proto.mw.customer.VerifyStudentEmailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.VerifyStudentEmailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.VerifyStudentEmailResponse}
 */
proto.mw.customer.VerifyStudentEmailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.VerifyStudentEmailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.VerifyStudentEmailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.VerifyStudentEmailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.VerifyStudentEmailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.VerifyStudentEmailResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.VerifyStudentEmailResponse} returns this
 */
proto.mw.customer.VerifyStudentEmailResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.mw.customer.VerifyStudentEmailResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.VerifyStudentEmailResponse} returns this
 */
proto.mw.customer.VerifyStudentEmailResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.StudentDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.StudentDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.StudentDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.StudentDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
mimeType: jspb.Message.getFieldWithDefault(msg, 2, ""),
data: msg.getData_asB64(),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.StudentDocument}
 */
proto.mw.customer.StudentDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.StudentDocument;
  return proto.mw.customer.StudentDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.StudentDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.StudentDocument}
 */
proto.mw.customer.StudentDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSizeBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.StudentDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.StudentDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.StudentDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.StudentDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string filename = 1;
 * @return {string}
 */
proto.mw.customer.StudentDocument.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.StudentDocument} returns this
 */
proto.mw.customer.StudentDocument.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string mime_type = 2;
 * @return {string}
 */
proto.mw.customer.StudentDocument.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.StudentDocument} returns this
 */
proto.mw.customer.StudentDocument.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes data = 3;
 * @return {!(string|Uint8Array)}
 */
proto.mw.customer.StudentDocument.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes data = 3;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.mw.customer.StudentDocument.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.mw.customer.StudentDocument.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.mw.customer.StudentDocument} returns this
 */
proto.mw.customer.StudentDocument.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional int64 size_bytes = 4;
 * @return {number}
 */
proto.mw.customer.StudentDocument.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.StudentDocument} returns this
 */
proto.mw.customer.StudentDocument.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.UploadStudentDocumentsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.UploadStudentDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.UploadStudentDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.UploadStudentDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.mw.customer.StudentDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.UploadStudentDocumentsRequest}
 */
proto.mw.customer.UploadStudentDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.UploadStudentDocumentsRequest;
  return proto.mw.customer.UploadStudentDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.UploadStudentDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.UploadStudentDocumentsRequest}
 */
proto.mw.customer.UploadStudentDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    case 2:
      var value = new proto.mw.customer.StudentDocument;
      reader.readMessage(value,proto.mw.customer.StudentDocument.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.UploadStudentDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.UploadStudentDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.UploadStudentDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mw.customer.StudentDocument.serializeBinaryToWriter
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.UploadStudentDocumentsRequest} returns this
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated StudentDocument documents = 2;
 * @return {!Array<!proto.mw.customer.StudentDocument>}
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.mw.customer.StudentDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mw.customer.StudentDocument, 2));
};


/**
 * @param {!Array<!proto.mw.customer.StudentDocument>} value
 * @return {!proto.mw.customer.UploadStudentDocumentsRequest} returns this
*/
proto.mw.customer.UploadStudentDocumentsRequest.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mw.customer.StudentDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.StudentDocument}
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mw.customer.StudentDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.UploadStudentDocumentsRequest} returns this
 */
proto.mw.customer.UploadStudentDocumentsRequest.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mw.customer.UploadStudentDocumentsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.UploadStudentDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.UploadStudentDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.UploadStudentDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
documentIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse}
 */
proto.mw.customer.UploadStudentDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.UploadStudentDocumentsResponse;
  return proto.mw.customer.UploadStudentDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.UploadStudentDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse}
 */
proto.mw.customer.UploadStudentDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addDocumentIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.UploadStudentDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.UploadStudentDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.UploadStudentDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDocumentIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse} returns this
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse} returns this
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string document_ids = 3;
 * @return {!Array<string>}
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.getDocumentIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse} returns this
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.setDocumentIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse} returns this
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.addDocumentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mw.customer.UploadStudentDocumentsResponse} returns this
 */
proto.mw.customer.UploadStudentDocumentsResponse.prototype.clearDocumentIdsList = function() {
  return this.setDocumentIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetStudentStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetStudentStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetStudentStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetStudentStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
authToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetStudentStatusRequest}
 */
proto.mw.customer.GetStudentStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetStudentStatusRequest;
  return proto.mw.customer.GetStudentStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetStudentStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetStudentStatusRequest}
 */
proto.mw.customer.GetStudentStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetStudentStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetStudentStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetStudentStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetStudentStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string auth_token = 1;
 * @return {string}
 */
proto.mw.customer.GetStudentStatusRequest.prototype.getAuthToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetStudentStatusRequest} returns this
 */
proto.mw.customer.GetStudentStatusRequest.prototype.setAuthToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mw.customer.GetStudentStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mw.customer.GetStudentStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetStudentStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
isStudent: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
isVerified: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
verificationStart: jspb.Message.getFieldWithDefault(msg, 3, ""),
verificationEnd: jspb.Message.getFieldWithDefault(msg, 4, ""),
paypalOrderCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
canUseInvoice: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
rejectionReason: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mw.customer.GetStudentStatusResponse}
 */
proto.mw.customer.GetStudentStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mw.customer.GetStudentStatusResponse;
  return proto.mw.customer.GetStudentStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mw.customer.GetStudentStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mw.customer.GetStudentStatusResponse}
 */
proto.mw.customer.GetStudentStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsStudent(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVerified(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationEnd(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaypalOrderCount(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanUseInvoice(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRejectionReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mw.customer.GetStudentStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mw.customer.GetStudentStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mw.customer.GetStudentStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsStudent();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsVerified();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getVerificationStart();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVerificationEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPaypalOrderCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCanUseInvoice();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional bool is_student = 1;
 * @return {boolean}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getIsStudent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setIsStudent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool is_verified = 2;
 * @return {boolean}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getIsVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setIsVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string verification_start = 3;
 * @return {string}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getVerificationStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setVerificationStart = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string verification_end = 4;
 * @return {string}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getVerificationEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setVerificationEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 paypal_order_count = 5;
 * @return {number}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getPaypalOrderCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setPaypalOrderCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool can_use_invoice = 6;
 * @return {boolean}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getCanUseInvoice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setCanUseInvoice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string rejection_reason = 8;
 * @return {string}
 */
proto.mw.customer.GetStudentStatusResponse.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mw.customer.GetStudentStatusResponse} returns this
 */
proto.mw.customer.GetStudentStatusResponse.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


goog.object.extend(exports, proto.mw.customer);
